module.exports = __webpack_public_path__ + "static/media/optum.b237148f.svg";